import { telefonoParaMostrar } from "../../../helpers/telefonoWhatsapp";
import React, { useState } from "react";
import FichaCliente from "./FichaCliente";
import { claveDeLinea, nombreDeLinea } from "../../../helpers/beautyLineas";
import { WhatsappLink } from "../../components/Whatsapp";
import RecordatorioLineas from "../../recordatorios/RecordatorioLineas";
import { lineasDeRecordatorio } from "../../recordatorios/recordatorios";
import { formatAxisMinute } from "../../reservas/components/dailyCourtGridLayout";
import {
  duracionLabel,
  nombreCliente,
  plata,
  puedeCancelar,
  puedeConfirmar,
  puedeMarcarIngreso,
  puedeMover,
  puedeNoShow,
  estadoVisible,
  minutosPreparacion,
  preparacionHasta,
  statusMeta,
} from "./agendaLayout";
import { serieDescripcion, serieProgreso, tieneSerie } from "./turnoFijoModel";
import "../../reservas/reservas-organizer.css";
import "./agenda.css";

/* TurnoDetalle — ficha de un turno con sus acciones. Las acciones las resuelve AgendaTab (confirmación y recarga). */

// Values from TableReservation.paymentstatus / refundStatus.
const PAGO = { none: "Sin seña", pending: "Seña pendiente", paid: "Seña pagada", partial: "Seña pagada en parte", failed: "Pago fallido" };
const REINTEGRO = { pending_organizer: "A reintegrar por el salón (manual)", refunded: "Reintegrada", none: "", not_applicable: "" };

const REAGENDADO_POR = { customer: "último por el cliente", organizer: "último por el salón" };

const TurnoDetalle = ({ turno, onClose, onAccion, onMover, onVerSeries, puedeDesvincular = false }) => {
  const [verFicha, setVerFicha] = useState(false);
  const meta = statusMeta(estadoVisible(turno));
  const sena = Number(turno.depositAmount) || 0;
  const pago = PAGO[turno.paymentstatus] || turno.paymentstatus || "";
  const reintegro = REINTEGRO[turno.refundStatus] ?? turno.refundStatus ?? "";
  const preparacion = minutosPreparacion(turno);
  const preparacionFin = preparacionHasta(turno);
  const origen = turno.bookingOrigin === "organizer" ? "Carga manual" : "Reserva online";
  const hayRecordatorios = lineasDeRecordatorio(turno.reminder).length > 0;

  const enSerie = tieneSerie(turno);
  const esCancelado = turno.status === "cancelled";
  const esNoShow = turno.status === "no_show";

  if (verFicha) {
    return (
      <FichaCliente
        key={turno._id}
        reservationId={turno._id}
        puedeDesvincular={puedeDesvincular}
        onVolver={() => setVerFicha(false)}
        onClose={onClose}
      />
    );
  }

  return (
    <div className="zr-overlay" onMouseDown={onClose}>
      <div
        className="zr-modal ba-modal ba-modal--detalle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="zr-turno-detalle-title"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <button type="button" className="ba-modal__close" aria-label="Cerrar detalle del turno" onClick={onClose}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
            <path d="m6 6 12 12M18 6 6 18" />
          </svg>
        </button>
        <div className="zr-modal__icon">
          <svg
            width="56"
            height="56"
            viewBox="0 0 24 24"
            fill="currentColor"
            style={{ color: "var(--zr-lime)" }}
          >
            <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm-1.5 5.5a1.5 1.5 0 0 1 3 0v6a1.5 1.5 0 0 1-3 0zM12 18.4a1.7 1.7 0 1 1 0-3.4 1.7 1.7 0 0 1 0 3.4z" />
          </svg>
        </div>

        <h3 id="zr-turno-detalle-title" className="zr-modal__title">
          Detalle del turno
        </h3>

        {(meta.label || enSerie) && (
          <div style={{ marginBottom: "16px" }}>
            {meta.label && (
              <span
                className={`zr-badge ${
                  esCancelado || esNoShow
                    ? "zr-badge--cancel"
                    : meta.tone === "pending"
                    ? "zr-badge--pending"
                    : ""
                }`}
              >
                <span className="dot" />
                {meta.label}
              </span>
            )}
            {enSerie && (
              <span className="zr-badge zr-badge--series" style={meta.label ? { marginLeft: 6 } : undefined}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M17 2l4 4-4 4" />
                  <path d="M3 11V9a3 3 0 0 1 3-3h15" />
                  <path d="M7 22l-4-4 4-4" />
                  <path d="M21 13v2a3 3 0 0 1-3 3H3" />
                </svg>
                Turno fijo
              </span>
            )}
          </div>
        )}

        <p className="zr-modal__text ba-modal__summary">
          <strong>{nombreCliente(turno)}</strong>
          {turno.reservationCode && (
            <>
              <br />
              Cód. #{turno.reservationCode}
            </>
          )}
          <br />
          {formatAxisMinute(turno.startMin)} a {formatAxisMinute(turno.endMin)}hs ({duracionLabel(turno.durationMinutes || turno.endMin - turno.startMin)})
        </p>

        <dl className="ba-detalle">
          <dt>Profesional</dt>
          <dd>{turno.professionalName || "-"}{turno.professionalChoice === "any" ? " (sin preferencia)" : ""}</dd>
          <dt>Servicios</dt>
          <dd>
            {(turno.services || []).map((s, i) => (
              <div key={claveDeLinea(s, i)}>{nombreDeLinea(s)} · {duracionLabel(s.durationMinutes)} · {plata(s.price)}</div>
            ))}
          </dd>
          {preparacion > 0 && (
            <>
              <dt>Preparación</dt>
              <dd>
                {preparacion} min al terminar
                {preparacionFin && <small>El horario queda tomado hasta las {preparacionFin}.</small>}
              </dd>
            </>
          )}
          {enSerie && (
            <>
              <dt>Turno fijo</dt>
              <dd>
                {serieDescripcion(turno.series)}
                <small>
                  {serieProgreso(turno.series)}
                  {onVerSeries && (
                    <>
                      {" · "}
                      <button type="button" className="ba-detalle__link" onClick={onVerSeries}>
                        Ver turnos fijos
                      </button>
                    </>
                  )}
                </small>
              </dd>
            </>
          )}
          <dt>Total</dt>
          <dd style={{ fontWeight: 600 }}>{plata(turno.totalPrice)}</dd>
          {(sena > 0 || pago) && (
            <>
              <dt>Seña</dt>
              <dd>{sena > 0 ? plata(sena) : "Sin seña"}{pago ? ` · ${pago}` : ""}</dd>
            </>
          )}
          {reintegro && (
            <>
              <dt>Reintegro</dt>
              <dd>{reintegro}</dd>
            </>
          )}
          {Number(turno.rescheduleCount) > 0 && (
            <>
              <dt>Reagendado</dt>
              <dd>
                {turno.rescheduleCount === 1 ? "Reagendado 1 vez" : `Reagendado ${turno.rescheduleCount} veces`}
                {REAGENDADO_POR[turno.lastRescheduledBy] ? ` (${REAGENDADO_POR[turno.lastRescheduledBy]})` : ""}
              </dd>
            </>
          )}
          <dt>Teléfono</dt>
          <dd>
            {telefonoParaMostrar(turno.phone) || "-"}
            <WhatsappLink phone={turno.phone} name={nombreCliente(turno)} className="odcg-item-wa ba-wa-inline" />
          </dd>
          <dt>Origen</dt>
          <dd>{origen}</dd>
          {hayRecordatorios && (
            <>
              <dt>Recordatorios</dt>
              <dd>
                <RecordatorioLineas reminder={turno.reminder} className="zr-recordatorios--detalle" />
              </dd>
            </>
          )}
          {turno.notes && (
            <>
              <dt>Notas</dt>
              <dd>{turno.notes}</dd>
            </>
          )}
        </dl>

        <div className="zr-modal__actions zr-modal__actions--reservation-detail">
          <button type="button" className="zr-btn zr-btn--soft zr-modal__action" onClick={() => setVerFicha(true)}>
            Ver ficha del cliente
          </button>
          <button type="button" className="zr-btn zr-btn--ghost zr-modal__action" onClick={onClose}>
            Volver
          </button>
          {onMover && puedeMover(turno) && (
            <button type="button" className="zr-btn zr-btn--soft zr-modal__action" onClick={() => onMover(turno)}>
              Mover turno
            </button>
          )}
          {puedeConfirmar(turno) && (
            <button type="button" className="zr-btn zr-btn--dark zr-modal__action" onClick={() => onAccion("confirm")}>
              Confirmar
            </button>
          )}
          {puedeMarcarIngreso(turno) && (
            <button type="button" className="zr-btn zr-btn--dark zr-modal__action zr-reservation-action" onClick={() => onAccion("checkin")}>
              Marcar ingreso
            </button>
          )}
          {puedeCancelar(turno) && (
            <button
              type="button"
              className="zr-pill-btn zr-modal__action zr-modal__action--danger"
              onClick={() => onAccion("cancel")}
            >
              Cancelar turno
            </button>
          )}
          {puedeNoShow(turno) && (
            <button
              type="button"
              className="zr-pill-btn zr-modal__action zr-modal__action--danger"
              onClick={() => onAccion("no-show")}
            >
              No asistió
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TurnoDetalle;
